// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3BT4Y","main":"App_main__aDOxM","aside":"App_aside__1PzL3","content":"App_content__11LHs","header":"App_header__3MgOT","body":"App_body__3UyqE"};